import { useUser } from '@clerk/clerk-react'

export interface UseIsAdminResult {
  isLoaded: boolean
  isAdmin: boolean
}

/**
 * Returns whether the current signed-in user has admin access:
 * org:admin membership OR publicMetadata.role === 'admin'.
 *
 * Canonical copy — was previously duplicated verbatim across admin,
 * meetings, timeoff, and timesheet.
 */
export function useIsAdmin(): UseIsAdminResult {
  const { user, isLoaded } = useUser()
  if (!isLoaded || !user) return { isLoaded, isAdmin: false }
  const hasOrgAdmin = user.organizationMemberships.some((m) => m.role === 'org:admin')
  const hasRoleAdmin =
    (user.publicMetadata as Record<string, unknown> | undefined)?.role === 'admin'
  return { isLoaded, isAdmin: hasOrgAdmin || hasRoleAdmin }
}
